import React from "react";

/**
 * The Spotter brand mark — a reticle (scope crosshair + locked-on center dot). Chosen over a few
 * alternatives (locate-pin-in-wordmark, yard-hash bracket, radar sweep, crest monogram) for
 * being the one that still reads as a target at small sizes, and for the double meaning: a
 * broadcast spotter's viewfinder, and "the exact spot" a mapped field lands on. Renders in
 * `--spotterAccentBright` so it's the sole carrier of the header's accent color — the wordmark next
 * to it is solid, not two-tone, on purpose (see `SpotterHeader.tsx`).
 */
const SpotterMark = ({ size = 22 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    aria-hidden="true"
    focusable="false"
  >
    <circle
      cx="14"
      cy="14"
      r="8"
      fill="none"
      stroke="var(--spotterAccentBright)"
      strokeWidth="1.7"
    />
    <circle cx="14" cy="14" r="1.7" fill="var(--spotterAccentBright)" />
    <line
      x1="14"
      y1="1.5"
      x2="14"
      y2="5.5"
      stroke="var(--spotterAccentBright)"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <line
      x1="14"
      y1="22.5"
      x2="14"
      y2="26.5"
      stroke="var(--spotterAccentBright)"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <line
      x1="1.5"
      y1="14"
      x2="5.5"
      y2="14"
      stroke="var(--spotterAccentBright)"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <line
      x1="22.5"
      y1="14"
      x2="26.5"
      y2="14"
      stroke="var(--spotterAccentBright)"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </svg>
);

export default SpotterMark;
